import type { ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import { useResetState, useExportTable, useRequest } from "hooks";
import type {
    Transaction,
    TransactionResponse,
    TransactionsResponse
} from "./types";
import { getTransactionDetailsThunk, getTransactionsThunk } from "./thunks";
import { changeExportLoading, resetState } from "./slice";

const useActions = () => {
    const getTransactions = useRequest<ThunkReturnType<TransactionsResponse>, string>({
        thunk: getTransactionsThunk
    });

    const getTransactionDetails = useRequest<
        ThunkReturnType<TransactionResponse>,
        Pick<Transaction, 'coreId' | 'MOR'>
    >({
        thunk: getTransactionDetailsThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetTransactions
    });

    const resetTransactions = useResetState(resetState);

    return {
        resetTransactions,
        getTransactions,
        downloadCsv,
        getTransactionDetails
    };
};

export default useActions;
